import { render, staticRenderFns } from "./SmallYellowButton.vue?vue&type=template&id=42ea12b4&scoped=true&"
import script from "./SmallYellowButton.vue?vue&type=script&lang=js&"
export * from "./SmallYellowButton.vue?vue&type=script&lang=js&"
import style0 from "./SmallYellowButton.vue?vue&type=style&index=0&id=42ea12b4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ea12b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
